import { Opportunity } from "@/opportunity/opportunity";
import React from "react";
import OpportunityDetectionsTimeline from "@/opportunity/opportunity_detail_page/OpportunityDetectionsTimeline";
import { CollapsibleCard } from "@/opportunity/opportunity_detail_page/CollapsibleCard";

const OpportunityIssueValidationCard = ({ 
  opportunity, 
  showStaffView 
}: { 
  opportunity: Opportunity;
  showStaffView: boolean;
}) => {
  return (
    <CollapsibleCard title="Detections" defaultOpen={false}>
      <OpportunityDetectionsTimeline 
        opportunity={opportunity} 
        showStaffView={showStaffView}
      />
    </CollapsibleCard>
  )
}

export default OpportunityIssueValidationCard;
